import React from "react";
import { Provider } from "react-redux";
import { Route, Routes } from "react-router-dom";

import NewNotebookForm from "./components/NewNotebookForm";
import NotebooksHome from "./components/NotebooksHome";
import "./Notebooks.css";
import { initStore } from "./state";

type Props = { onRouteNotFound?: () => void };

export default class Notebooks extends React.Component<Props> {
  render() {
    const { onRouteNotFound } = this.props;
    const store = initStore();
    return (
      <Provider store={store}>
        <Routes>
          <Route path="/" element={<NotebooksHome />} />
          <Route path="/new" element={<NewNotebookForm />} />
          <Route
            path="*"
            element={
              onRouteNotFound ? <>{onRouteNotFound()}</> : <p>404 Not Found</p>
            }
          />
        </Routes>
      </Provider>
    );
  }
}
